import { z } from "zod";

/**
 * GET /api/v1/health/live — is the process alive?
 * Touches no external dependency: if it answers, the container must not be
 * restarted.
 */
export const livenessResponseSchema = z.object({
  status: z.literal("ok"),
  uptimeSeconds: z.number().nonnegative(),
  timestamp: z.iso.datetime(),
});

export type LivenessResponse = z.infer<typeof livenessResponseSchema>;

export const dependencyStatusSchema = z.object({
  name: z.literal("postgres"),
  status: z.enum(["up", "down"]),
  latencyMs: z.number().nonnegative().optional(),
  error: z.string().optional(),
});

export type DependencyStatus = z.infer<typeof dependencyStatusSchema>;

/**
 * GET /api/v1/health/ready — can it serve traffic?
 * Checks dependencies and returns 503 if any of them is down.
 */
export const readinessResponseSchema = z.object({
  status: z.enum(["ready", "not_ready"]),
  timestamp: z.iso.datetime(),
  dependencies: z.array(dependencyStatusSchema),
});

export type ReadinessResponse = z.infer<typeof readinessResponseSchema>;
